var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAssistsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2866",
    "data-name": "Group 2866",
    transform: "translate(-131 -595)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1301",
    "data-name": "Rectangle 1301",
    width: 25,
    height: 25,
    transform: "translate(131 595)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2865",
    "data-name": "Group 2865",
    transform: "translate(-239.797 300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M-2.929-5.858A12.071,12.071,0,0,0,9.142-17.929,12.071,12.071,0,0,0-2.929-30,12.071,12.071,0,0,0-15-17.929,12.071,12.071,0,0,0-2.929-5.858",
    transform: "translate(386.227 325)",
    fill: "#9a9b9f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ico_menu",
    transform: "translate(376.648 300.943)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1123",
    "data-name": "Rectangle 1123",
    width: 14,
    height: 14,
    transform: "translate(-0.422 -0.943)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_14",
    "data-name": "Union 14",
    d: "M0,6.982V6.207H9.072v.775Zm0-3.1V3.1H9.072v.776Zm0-3.1V0H9.072V.776Z",
    transform: "translate(1.923 2.437)",
    fill: "#fff"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistsicon);
export default __webpack_public_path__ + "static/media/assistsicon.319fb78081365a5a3e7f3503e343e8c9.svg";
export { ForwardRef as ReactComponent };